import { configureStore } from "@reduxjs/toolkit";
import { 
  persistStore, 
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import authReducer from "../reducer/authprovider";
import rememberMeReducer from "../reducer/rememberme";
import appSettingReducer from "../reducer/appsetting"; 
import eventsReducer from "../reducer/events";

// Config for persisting only auth and rememberMe
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "rememberMe"], // Only persist auth and rememberMe
};

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  rememberMe: rememberMeReducer,
  appSetting: appSettingReducer,
  events: eventsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
